// T.C./pasaport sunucudan yıldızlı gelir: arama sunucuda, tam numara yalnız dışa aktarma anında
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchTcMap = async (ids) => (ids.length ? (await axios.post(`${API}/employees/tc-lookup`, { ids })).data : {});

export const withFullTc = async (list) => {
  const map = await fetchTcMap([...new Set(list.map(e => e.id).filter(Boolean))]);
  return list.map(e => (map[e.id] ? { ...e, tc_kimlik_no: map[e.id] } : e));
};

// Rakam içeren aramada eşleşen personel id'leri (sunucuda tam numarayla); aksi halde null
export const useTcSearchIds = (query, minLen = 3) => {
  const [ids, setIds] = useState(null);
  const q = (query || '').trim();
  const active = q.length >= minLen && /\d/.test(q);
  useEffect(() => {
    if (!active) { setIds(null); return; }
    let live = true;
    const t = setTimeout(() => {
      axios.get(`${API}/employees?q=${encodeURIComponent(q)}&include_archived=true&page_size=500&fields=id`)
        .then(r => live && setIds(new Set((r.data.items || []).map(e => e.id))))
        .catch(() => live && setIds(new Set()));
    }, 300);
    return () => { live = false; clearTimeout(t); };
  }, [q, active]);
  return active ? ids || new Set() : null;
};
